module.exports = __webpack_public_path__ + "static/img/20-2.3127cd9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/issue11/06/20-2.jpg
// module id = L+Hj
// module chunks = 7